import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RxFormGroup } from '@rxweb/reactive-form-validators';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BroadcastService } from '../../../../../shared/services/broadcast.service';
import { FormService } from '../../../../../shared/services/form.service';
import { ReelsService } from '../../../../../services/reels.service';
import { ReelModel } from '../models/reels.model';
import { EventType } from '../../../../../shared/interfaces/event.model';
import { GroupsService } from '../../../../../services/groups.service';
import { ReelCategoriesService } from '../../../../../services/reel-categories.service';
import { LayoutsService } from '../../../../../services/layouts.service';
import { CustomersService } from '../../../../../services/customers.service';
@Component({
	selector: 'app-create-edit-reel',
	templateUrl: './create-edit-reel.component.html',
	styleUrls: ['./create-edit-reel.component.scss']
})
export class CreateEditReelComponent implements OnInit, OnDestroy {

	@Input() data: any = {};
	formGroup: RxFormGroup;
	fields: any = {
		name: {
			type: 'input',
			options: {
				path: 'name',
				class: 'col-sm-12',
				label: {
					text: 'Nombre',
					class: 'col-sm-12'
				}
			}
		},
		type: {
			type: 'select',
			options: {
				path: 'type',
				label: {
					text: 'Tipo de Reel'
				},
				dropdown: {
					text: 'Seleccione...',
					options: [
						{
							id: 'IMAGE',
							name: 'Imagen'
						},
						{
							id: 'VIDEO',
							name: 'Video'
						}
					]
				}
			}
		},
		groups_id: {
			type: 'select',
			options: {
				path: 'groups_id',
				label: {
					text: 'Grupo de Autobuses'
				},
				dropdown: {
					text: 'Seleccione...',
					options: []
				}
			}
		},
		client_id: {
			type: 'select',
			options: {
				path: 'client_id',
				label: {
					text: 'Partner'
				},
				dropdown: {
					text: 'Seleccione...',
					options: []
				}
			}
		},
		reel_categories_id: {
			type: 'select',
			options: {
				path: 'reel_categories_id',
				label: {
					text: 'Categoria de Reel'
				},
				dropdown: {
					text: 'Seleccione...',
					options: []
				}
			}
		},
		layoutIdScreenId: {
			type: 'select',
			options: {
				path: 'layoutIdScreenId',
				label: {
					text: 'Layout'
				},
				dropdown: {
					text: 'Seleccione...',
					optionsLabelField: 'nameWithScreen',
					optionsValueField: 'layoutIdScreenId',
					options: []
				}
			}
		},
		active: {
			type: 'switch',
			options: {
				path: 'active',
				label: {
					text: '¿Activo?'
				},
				switchers: {
					trueCaption: 'Si',
					falseCaption: 'No'
				}
			}
		}
	};
	isAdmin: boolean = false;
	reelCategories = [];
	availableLayouts = [];
	selectedGroup = null;

	get isImageType(): boolean {
		return this.formGroup.get('type').value;
	}

	private isUpdatingLayouts = false;
	private atComponentDestroy = new Subject();

	constructor(
		private cdr: ChangeDetectorRef,
		public modalRef: BsModalRef,
		private broadcast: BroadcastService,
		private formService: FormService,
		private reelsService: ReelsService,
		private groupsService: GroupsService,
		private reelCategoriesService: ReelCategoriesService,
		private layoutsService: LayoutsService,
		private customersService: CustomersService
	) {
		this.formService._formEvents
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(data => {
				this.formGroup = data;
			});
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next();
		this.atComponentDestroy.unsubscribe();
	}

	async ngOnInit(): Promise<void> {
		this.isAdmin = this.data?.is_admin || false;

		await this.formService.transformIntoFormGroup(ReelModel, this.data);
				if (this.fields.client_id) {
		try {
			const clientsResponse = await this.customersService.getAll();
			const clients = (clientsResponse.data ?? []).map(client => ({
			id: client.id,
			name: client.name
			}));
			this.fields.client_id.options.dropdown.options = [...clients];
		} catch (e) {
			console.error("Error al cargar partner", e);
		}
		}
		const [groups, reelCategories, layouts] = await Promise.all([
			this.groupsService.getAll(),
			this.reelCategoriesService.getAll(),
			this.layoutsService.getAll()
		]);

		this.fields.groups_id.options.dropdown.options = groups.response;

		this.reelCategories = reelCategories.response.map(data => ({ id: data.id, name: data.title, type: data.type }));
		if (this.data?.id) {
			if (this.data.groups_id != null) {
				await this.setOptionsLayouts(this.data.groups_id);
				this.formGroup.get('layouts_id').setValue(this.data.layouts_id);
				this.formGroup.get('screenId').setValue(this.data.screenId);
			}
		}

		if (this.data?.id) {
			if (this.data.groups_id !== null) {
				this.formGroup.get('groups_id').setValue(null, { emitEvent: false });
				setTimeout(() => {
					this.formGroup.get('groups_id').setValue(this.data.groups_id, { emitEvent: false });
					this.setOptionsLayouts(this.data.groups_id);
				});
			}
		}

		this.formGroup.valueChanges
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(data => {
				if (data.groups_id !== null) {
					this.formGroup.get('groups_id').setValue(null, { emitEvent: false });
					setTimeout(() => {
						this.formGroup.get('groups_id').setValue(data.groups_id, { emitEvent: false });
						this.setOptionsLayouts(data.groups_id);
					});
				}
				if (data.type !== null) {
					this.setOptionsCategoryReel(data.type);
				}
			});




		const type = this.formGroup.get('type').value;

		this.fields.reel_categories_id.options.dropdown.options =
			[...this.reelCategories.filter(dataValue => dataValue.type === type)];
	}

	/**
	 * Send data to the server
	 */
	submit(): void {
		this.reelsService.createOrUpdate(this.formGroup, this.data?.id)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(
				data => {
					this.broadcast.reloadDataTable();
					this.broadcast.reloadInit();
					this.modalRef.hide();
				}
			);
	}

	/**
	 * Helper function to transform an Object into an Array
	 * @param enumme
	 * @returns
	 */
	toArray(enumme): any[] {
		return Object.keys(enumme)
			.map(key => ({ id: key, name: enumme[key] }));
	}

	/**
	 * Set the options for the Category Reel field
	 * @param type
	 */

	setOptionsCategoryReel(type: string) {

		this.fields.reel_categories_id.options.dropdown.options = [...this.reelCategories.filter(data => data.type == type)];
	}

	/**
	 * Set the options for Layouts field
	 * @param groupId
	 */


	async setOptionsLayouts(groupId: number) {
		if (this.isUpdatingLayouts) {
			return;
		}

		this.isUpdatingLayouts = true;

		try {
			if (this.selectedGroup === groupId) {
				return;
			}

			const layoutIdScreenIdValue = this.formGroup.get('layoutIdScreenId').value;
			if (layoutIdScreenIdValue && typeof layoutIdScreenIdValue === 'string') {
				const layoutIdScreenIdArray = layoutIdScreenIdValue.split(',');
				if (layoutIdScreenIdArray.length > 0) {
					this.formGroup.get('layouts_id').setValue(layoutIdScreenIdArray[0]);
				}
				if (layoutIdScreenIdArray.length > 1) {
					this.formGroup.get('screenId').setValue(layoutIdScreenIdArray[1]);
				}
			}

			const layouts = await this.layoutsService.getLayoutsByGroupId(groupId);

			if (JSON.stringify(this.availableLayouts) !== JSON.stringify(layouts.response)) {
				this.availableLayouts = layouts.response;
				this.fields.layoutIdScreenId.options.dropdown.options = layouts.response;
			}

			// Marca el componente para detección de cambios (solo si es necesario)
			this.cdr.markForCheck();
		} catch (error) {
			console.error('Error al obtener layouts:', error);
		} finally {
			this.isUpdatingLayouts = false;
		}
	}
}
